import { AsyncState, HttpResult, loadedAsyncState, loadingAsyncState, Unit } from "widgets-for-react";
import {
  ActiveSubscription,
  ChangePasswordResult,
  LookupData,
  OpenPayment,
  Subscription,
  SubscriptionResult,
  UserSubscriptions
} from "./subscriptionState";
import { NewSubscriptionState } from "./newSubscription/newSubscriptionState";
import { ResumeSubscriptionState } from "./resumeSubscription/resumeSubscriptionState";
import { ChangePaymentMethodState } from "./changePaymentMethod/changePaymentMethodState";
import { IDealIssuer, PaymentType } from "../forms/paymentMethod/paymentMethodState";
import { Country } from "forms/country/countryState";
import { Job } from "forms/job/jobState";
import { ChangePasswordState } from "forms/changePassword/changePasswordState";
import { CompanyState } from "forms/company/companyState";
import { PersonalInfoState } from "forms/personalInfo/personalInfoState";
import { Language } from "forms/language/languageState";
import { Invoice } from "forms/invoiceSelector/invoiceSelectorState";
import { DataLayer } from "utils/datalayer";
import { StripeUpgradeSubscriptionState } from "./stripeUpgradeSubscription/stripeUpgradeSubscriptionState";
import i18next from "i18next";

export const invoiceSampleResponse =
{
  "Title": "Invoice 103007 to $giuseppemag",
  "BillToCompanyName": null,
  "BillToNameSurname": "Giuseppe Maggiore",
  "BillToAddress": "Lloydstraat 138",
  "BillToPostcode": "3024EA",
  "BillToCity": "Rotterdam",
  "BillToCountry": "Nederlands",
  "BillToVAT": "ab123456",
  "BillToMemberId": "K00430",
  "InvoiceInfoNumber": "103007",
  "InvoiceInfoDate": "2021-05-20T22:00:00Z",
  "InvoiceKind": "Regular",
  "ServiceDescription": "subscription:ProMonthlyName",
  "ServiceFrom": "2021-05-20T22:00:00Z",
  "ServiceTo": "2021-05-20T22:00:00Z",
  "CorrectionFor": "103007",
  "JsonBody": {
    "@odata.etag": "W/\"JzQ0OzBvb3U1V09Ca1ZFdHpkV2l5MDA4RTk2eHhVcmxUelFwNE5rb1gzUWJMUDg9MTswMDsn\"",
    "id": "3976be08-31ba-eb11-9f0a-00224884b79a",
    "number": "103007",
    "externalDocumentNumber": "",
    "invoiceDate": "2021-05-21",
    "postingDate": "2021-05-21",
    "dueDate": "2021-05-21",
    "customerPurchaseOrderReference": "",
    "customerId": "9dd7fba5-30ba-eb11-9f0a-00224884b79a",
    "customerNumber": "K00190",
    "customerName": "Giuseppe Maggiore",
    "billToName": "Giuseppe Maggiore Holding",
    "billToCustomerId": "2d938ecb-30ba-eb11-9f0a-00224884b79a",
    "billToCustomerNumber": "K00200",
    "shipToName": "Giuseppe Maggiore",
    "shipToContact": "",
    "sellToAddressLine1": "Lariksstraat 1",
    "sellToAddressLine2": "",
    "sellToCity": "Rotterdam",
    "sellToCountry": "NL",
    "sellToState": "NL",
    "sellToPostCode": "3038AB",
    "billToAddressLine1": "Wijnhaven 2",
    "billToAddressLine2": "",
    "billToCity": "Rotterdam",
    "billToCountry": "NL",
    "billToState": "NL",
    "billToPostCode": "3038AB",
    "shipToAddressLine1": "Lariksstraat 1",
    "shipToAddressLine2": "",
    "shipToCity": "Rotterdam",
    "shipToCountry": "NL",
    "shipToState": "NL",
    "shipToPostCode": "3038AB",
    "currencyId": "00000000-0000-0000-0000-000000000000",
    "currencyCode": "EUR",
    "orderId": "00000000-0000-0000-0000-000000000000",
    "orderNumber": "",
    "paymentTermsId": "18006ad3-a0a8-ea11-a814-000d3a245d1d",
    "shipmentMethodId": "00000000-0000-0000-0000-000000000000",
    "salesperson": "",
    "pricesIncludeTax": true,
    "remainingAmount": 0,
    "discountAmount": 0,
    "discountAppliedBeforeTax": false,
    "totalAmountExcludingTax": 78.21,
    "totalTaxAmount": 20.79,
    "totalAmountIncludingTax": 99,
    "status": "Paid",
    "lastModifiedDateTime": "2021-05-21T12:36:54.32Z",
    "phoneNumber": "",
    "email": "test@test.com"
  },
  "UserId": 21.0,
  "Id": 1
}

export const lookupDataSampleResponse: LookupData = {
  "Countries": [
    { "Id": 1, "Title": "The Netherlands", "Created": "2021-06-05T12:13:57", "Modified": "2021-06-05T12:13:57" }],
  "Jobs": [{ "Id": 1, "Title": "chefKok", "Created": "2021-06-05T12:14:00", "Modified": "2021-06-05T12:14:00" }],
  "Subscriptions": [{ "Price": 0.0, "PaymentFrequency": "Monthly", "Currency": "€", "Id": 1, "Title": "subscription:TrialSubscriptionName" }],
  "IDealIssuers": [{ "BIC": "1234", "Id": 1, "Title": "ABN AMRO", "Created": "2021-06-05T12:13:28", "Modified": "2021-06-05T12:13:28" }],
  "Languages": [{ "Code": "nl", "Id": 1, "Title": "Nederlands", "Created": "0001-01-01T00:00:00", "Modified": "0001-01-01T00:00:00" }, { "Code": "en", "Id": 2, "Title": "English", "Created": "0001-01-01T00:00:00", "Modified": "0001-01-01T00:00:00" }],
  "Schools": [{ "Id": 1, "Title": "School", "Created": "2021-06-05T12:14:00", "Modified": "2021-06-05T12:14:00" }],
  "CompanyTypes": [{ "Title": "Restaurant" }]
}

export const userSubscriptionsSampleResponse: UserSubscriptions = {
  "User": {
    "Id": 1,
    "Name": "Giuseppe",
    "Surname": "Maggiore",
    "Username": "giuseppemag",
    "Email": "giuseppe@hoppinger.com",
    "PhoneNumber": "3161234567",
    "Gender": "Male",
    "Birthday": "1985-02-02T23:00:00Z",
    "Address": "Arie Hoospad",
    "Postcode": "3065NM",
    "Country": {
      "Id": 1
    },
    "Job": {
      "Id": 1
    },
    "Language": {
      "Id": 2,
      "Code": "en"
    },
    "ExpectedGraduationYear": 2021,
    "Company": {
      "Id": 1,
      "Title": "Hoppinger",
      "Address": "Lloydstraat 138",
      "Postcode": "3024EA",
      "City": "Rotterdam",
      "VAT": "AB12345678",
      "Type": "Restaurant",
      "Country": {
        "Id": 1
      }
    }
  },
  "ActiveSubscription": [
    {
      "Id": 22,
      "DateStarted": "2010-12-31T23:00:00Z",
      "Title": "asdasdasd",
      "Subscription": {
        "Id": 3,
        "Title": "Professional/yearly",
        "Description": "The main subscription for professionals.",
        "Price": 99.0,
        "Currency": "€",
        "CurrencyPaymentFrequency": "Yearly"
      },
      "RecurrentPayment": {
        "Id": 36,
        "Title": "zxczxczxc",
        "NextPaymentDate": "2010-12-31T23:00:00Z",
        "Status": "FirstSent",
        "OriginalPaymentType": null,
        "Frequency": null
      }
    }
  ],
  "PausedSubscriptions": [
    {
      "Id": 1,
      "Title": "GM's subscription",
      "DateStarted": "2010-12-31T23:00:00Z",
      "DatePaused": "2021-04-06T04:20:36Z",
      "NextPaymentDateWhenPaused": "2021-04-06T04:20:36Z",
      "SubscriptionLookup": {
        "LookupId": 4,
        "LookupValue": "Professional/monthly",
        "TypeId": "{f1d34cc0-9b50-4a78-be78-d5facfcccfb7}"
      },
      "Subscription": {
        "Id": 4,
        "Title": "Professional/monthly",
        "Description": "The main subscription for professionals.",
        "Price": 12.99,
        "Currency": "€",
        "PaymentFrequency": "Monthly"
      }
    }
  ],
  "OpenPayments": [
    {
      "User": {
        "Id": 1,
        "Title": "Giuseppe Majeur"
      },
      "Title": "Giuseppe Majeur - subscription:ProMonthlyName",
      "PaymentDate": "2021-06-15T03:08:07Z",
      "Amount": 9,
      "PaymentReference": "da138f91-ad8d-446e-b02e-240d607754fb",
      "Status": "Failed",
      "Id": 13
    },
    {
      "User": {
        "Id": 1,
        "Title": "Giuseppe Majeur"
      },
      "Id": 14,
      "Title": "Giuseppe Majeur - subscription:ProMonthlyName",
      "PaymentDate": "2021-07-15T03:10:08Z",
      "Amount": 9,
      "PaymentReference": "78410c9c-2e6b-4c59-a6c9-91d733a75d2f",
      "Status": "Failed",
    },
    {
      "User": {
        "Id": 1,
        "Title": "Giuseppe Majeur"
      },
      "Id": 15,
      "Title": "Giuseppe Majeur - subscription:ProYearlyName",
      "PaymentDate": "2021-06-12T03:12:45Z",
      "Amount": 99,
      "PaymentReference": "8063dcd1-4676-404c-ab95-af1848d40373",
      "Status": "Failed",
    }
  ],
  "HasOriginalTransactionKey": true,
  "PaywallStatus": "NoSubscription",
  "TrialDaysLeft": 11.9991087962963,
  "TerminationDate": "2021-04-06T04:20:36Z",
  "IsStripeCustomer": false,
  "StripeSubscription": {
    "Amount": 99,
    "NextPaymentDate": "2021-06-12T03:12:45Z",
    "PaymentFrequency": "yearly",
    "CancelAt": "2021-04-06T04:20:36Z",
    "TrialDaysLeft": 2,
    "ExternalId": "sub_1PEgqLI27OGS219FAQymSwaf"
  }
}

export type UserType =
  | 'trial'
  | 'pro'
  | 'expired' //expired is not a good name, but represents a user without a valid subscription
  | 'student'
  | 'teacher'
  | 'unknown'

export const userType = (
  userSubscriptionsState: AsyncState<UserSubscriptions>
): UserType =>
  userSubscriptionsState.kind === 'loaded'
    ? ['ValidTrial'].includes(userSubscriptionsState.value.PaywallStatus)
      ? 'trial'
      : [
          'ValidSubscription',
          'StillValidTerminatedSubscription',
          'ValidSubscriptionWithPaymentIssues',
        ].includes(userSubscriptionsState.value.PaywallStatus)
      ? 'pro'
      : [
          'ValidStudentSubscription',
          'ValidStudentSubscriptionWithPausedSubscription',
        ].includes(userSubscriptionsState.value.PaywallStatus)
      ? 'student'
      : [
          'ValidTeacherSubscription',
          'ValidTeacherSubscriptionWithPausedSubscription',
        ].includes(userSubscriptionsState.value.PaywallStatus)
      ? 'teacher'
      : ['NoSubscription', 'Blocked'].includes(
          userSubscriptionsState.value.PaywallStatus
        )
      ? 'expired'
      : 'unknown'
    : 'unknown'

export const getUserSubscription = async () => { 
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/ActiveSubscriptions`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      
      let value = json.Legacy as UserSubscriptions

      if (json.PaywallStatus) {
        value.PaywallStatus = json.PaywallStatus
      }

      // This value has been added later and thus is located outside of the api response legacy model
      value.IsStripeCustomer = json.IsStripeCustomer;
      value.StripeSubscription = json.StripeSubscription;

      let result: HttpResult<UserSubscriptions> = { 
        kind: "result", 
        value: value,
        status: 200
      }

      DataLayer.loggedInUserJobTitle(
        userType(loadedAsyncState(result.value)),
        result.value.User.Id.toString(),
        result.value.User.Job?.Id.toString()
      )

      return result
}

export const loadUserSubscriptions = (): AsyncState<UserSubscriptions> => loadingAsyncState(getUserSubscription);

interface CheckoutBody {
  subscriptionPriceId: string;
  firstName: string;
  surName: string;
  countryId: number;
  invoiceCountryId?: number;
  invoiceAddress?: string;
  invoiceCity?: string;
  invoicePostalCode?: string;
  vatNumber?: string;
  companyName?: string;
  companyType?: string;
}

export const startStripeCheckoutSession = (stripeUpgradeSubscriptionInput: StripeUpgradeSubscriptionState): AsyncState<SubscriptionResult> =>
  loadingAsyncState(async () => {
    let headers = new Headers()
    headers.append('content-type', 'application/json')
    
    let updateInfoBody =
    {
      name: stripeUpgradeSubscriptionInput.personalInfoState.input.name,
      surname: stripeUpgradeSubscriptionInput.personalInfoState.input.surname,
      phoneNumber: stripeUpgradeSubscriptionInput.personalInfoState.input.phoneNumber,
      gender: stripeUpgradeSubscriptionInput.personalInfoState.input.gender,
      dateOfBirth: stripeUpgradeSubscriptionInput.personalInfoState.input.dateOfBirth,
      countryId: stripeUpgradeSubscriptionInput.personalInfoState.countryState.input.Id,
      languageId: stripeUpgradeSubscriptionInput.personalInfoState.languageState.input.Id,
      jobId: stripeUpgradeSubscriptionInput.personalInfoState.jobState.input.Id,
      graduationYear: stripeUpgradeSubscriptionInput.personalInfoState.input.graduationYear
    }
    let updateInfoResponse = await fetch(`/api/v1/Checkout/ChangePersonalInfo`, {
      method: 'post',
      headers: headers,
      redirect: 'follow',
      body: JSON.stringify(updateInfoBody),
    })

    if (!updateInfoResponse.ok) throw Error(updateInfoResponse.statusText)

    let startCheckoutBody: CheckoutBody =
    {
      subscriptionPriceId: stripeUpgradeSubscriptionInput.subscriptionPriceSelectorState.input.Id ?? '',
      firstName: stripeUpgradeSubscriptionInput.personalInfoState.input.name ?? '',
      surName: stripeUpgradeSubscriptionInput.personalInfoState.input.surname ?? '',
      countryId: stripeUpgradeSubscriptionInput.personalInfoState.countryState.input.Id!
    }

    if(stripeUpgradeSubscriptionInput.isCompany) {
      startCheckoutBody = {
        ...startCheckoutBody,
        invoiceCity: stripeUpgradeSubscriptionInput.companyState.input.city,
        invoicePostalCode: stripeUpgradeSubscriptionInput.companyState.input.postCode,
        invoiceCountryId: stripeUpgradeSubscriptionInput.companyState.country.input.Id,
        vatNumber: stripeUpgradeSubscriptionInput.companyState.input.VAT,
        invoiceAddress: stripeUpgradeSubscriptionInput.companyState.input.address,
        companyName: stripeUpgradeSubscriptionInput.companyState.input.name,
        companyType: stripeUpgradeSubscriptionInput.companyState.companyType.input.Title
      }
    }

    let startCheckoutResponse = await fetch(`/api/v1/checkout`, {
      method: 'post',
      headers: headers,
      redirect: 'follow',
      body: JSON.stringify(startCheckoutBody),
    })
    if (!startCheckoutResponse.ok) throw Error(startCheckoutResponse.statusText)
    let json = await startCheckoutResponse.json()

    let result: HttpResult<SubscriptionResult> = {
      kind: "result",
      status: 200,
      value: {
        Kind: "Redirect",
        RedirectUrl: json.SessionUrl
      }
    }
    
    return result
  })


export const subscribeNow = (newSubscriptionInput: NewSubscriptionState): AsyncState<SubscriptionResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let checkoutBody =
      {
        personalInfo: {
          name: newSubscriptionInput.personalInfoState.input.name,
          surname: newSubscriptionInput.personalInfoState.input.surname,
          // email: newSubscriptionInput.personalInfoState.input.email,
          phoneNumber: newSubscriptionInput.personalInfoState.input.phoneNumber,
          gender: newSubscriptionInput.personalInfoState.input.gender,
          dateOfBirth: newSubscriptionInput.personalInfoState.input.dateOfBirth,
          // address: newSubscriptionInput.personalInfoState.input.address,
          // postcode: newSubscriptionInput.personalInfoState.input.postCode,
          // city: newSubscriptionInput.personalInfoState.input.city,
          invoiceAddress: {
            ...newSubscriptionInput.companyState.input,
            country: newSubscriptionInput.companyState.country.input,
            type: newSubscriptionInput.companyState.companyType.input.Title
          },
          invoiceToCompany: newSubscriptionInput.invoiceToCompany,
          country: newSubscriptionInput.personalInfoState.countryState.input,
          language: newSubscriptionInput.personalInfoState.languageState.input,
          job: newSubscriptionInput.personalInfoState.jobState.input,
        },
        paymentMethod: {
          paymentType: newSubscriptionInput.paymentMethodState.input.paymentType,
          iDealIssuer: newSubscriptionInput.paymentMethodState.input.iDealIssuer,
        },
        newSubscriptionId: newSubscriptionInput.subscriptionSelectorState.input.Id
      }
      let res = await fetch(`/api/v1/Checkout/SubscribeNow?changedExisting=false`, {
        method: 'post', credentials: 'include', headers: headers,
        redirect: 'follow', mode: 'no-cors',
        body: JSON.stringify(checkoutBody),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<SubscriptionResult> = { kind: "result", value: json as SubscriptionResult, status: 200 }
      return result
    })

export const changeSubscription = (newSubscription: Subscription): AsyncState<SubscriptionResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let checkoutBody =
      {
        newSubscriptionId: newSubscription.Id
      }
      let res = await fetch(`/api/v1/Checkout/SubscribeNow?changedExisting=true`, {
        method: 'post', credentials: 'include', headers: headers,
        redirect: 'follow', mode: 'no-cors',
        body: JSON.stringify(checkoutBody),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<SubscriptionResult> = { kind: "result", value: json as SubscriptionResult, status: 200 }
      return result
    })

export const pauseActiveSubscription = (subscription: ActiveSubscription): AsyncState<Unit> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/PauseActiveSubscription`, {
        method: 'post', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let result: HttpResult<Unit> = { kind: "result", value: {}, status: 200 }
      return result
    })

export const resumePausedSubscription = (resumeSubscriptionInput: ResumeSubscriptionState): AsyncState<SubscriptionResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')

      let checkoutBody =
      {
        paymentType: resumeSubscriptionInput.paymentMethodState.input.paymentType,
        iDealIssuer: resumeSubscriptionInput.paymentMethodState.input.iDealIssuer,
        invoiceAddress: {
          ...resumeSubscriptionInput.companyState.input,
          country: resumeSubscriptionInput.companyState.country.input
        },
        invoiceToCompany: resumeSubscriptionInput.invoiceToCompany,
        subscriptionId: resumeSubscriptionInput.subscriptionToResume.Id
      }
      let res = await fetch(`/api/v1/Checkout/ResumePausedSubscription?pausedSubscriptionId=${resumeSubscriptionInput.subscriptionToResume.Id}`, {
        method: 'post', credentials: 'include', headers: headers,
        redirect: 'follow', mode: 'no-cors',
        body: JSON.stringify(checkoutBody),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<SubscriptionResult> = { kind: "result", value: json as SubscriptionResult, status: 200 }
      return result
    })

export const loadAvailableSubscriptions = (): AsyncState<Array<Subscription>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/Subscriptions`, {
        method: 'get', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let subscriptions =
        (json.value as Array<Subscription>)
      let result: HttpResult<Array<Subscription>> = { kind: "result", value: subscriptions, status: 200 }
      return result
    })

export const loadAvailableCountries = (): AsyncState<Array<Country>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/Countries`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<Array<Country>> = { kind: "result", value: json.value as Array<Country>, status: 200 }
      return result
    })

export const loadAvailableLanguages = (): AsyncState<Array<Language>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/Languages`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<Array<Language>> = { kind: "result", value: json as Array<Language>, status: 200 }
      return result
    })

export const loadJobs = (): AsyncState<Array<Job>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/Jobs`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<Array<Job>> = { kind: "result", value: json as Array<Job>, status: 200 }
      return result
    })

export const changePaymentMethod = (changeSubscriptionInput: ChangePaymentMethodState): AsyncState<SubscriptionResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')

      let checkoutBody =
      {
        paymentType: changeSubscriptionInput.paymentMethodState.input.paymentType,
        iDealIssuer: changeSubscriptionInput.paymentMethodState.input.iDealIssuer,
      }

      let res = await fetch(`/api/v1/Checkout/ChangePaymentMethod`, {
        method: 'post', credentials: 'include', headers: headers,
        body: JSON.stringify(checkoutBody),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<SubscriptionResult> = { kind: "result", value: json as SubscriptionResult, status: 200 }
      return result
    })


export const payOpenInvoice = (openPayment: OpenPayment, paymentType: PaymentType, iDealIssuer?: Partial<IDealIssuer>): AsyncState<SubscriptionResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')

      let res = await fetch(`/api/v1/Checkout/PayOpenInvoice?openPaymentReference=${openPayment.PaymentReference}&paymentType=${paymentType}&iDealIssuerBIC=${iDealIssuer?.BIC || ""}`, {
        method: 'post', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<SubscriptionResult> = { kind: "result", value: json as SubscriptionResult, status: 200 }
      return result
    })

export type IDealIssuers = LookupData["IDealIssuers"]

export const getIDealIssuers = (): AsyncState<Array<IDealIssuer>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')

      let res = await fetch(`/api/v1/Checkout/IDealIssuers`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()

      let result: HttpResult<Array<IDealIssuer>> = {
        kind: "result",
        value: json as IDealIssuers,
        status: 200
      }
      return result
    }
  )

export const changePassword = (changePassword: ChangePasswordState): AsyncState<ChangePasswordResult> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let checkoutBody =
      {
        currentPassword: changePassword.input.current,
        newPassword: changePassword.input.new
      }
      let res = await fetch(`/api/v1/Checkout/ChangePassword`, {
        method: 'post', headers: headers,
        body: JSON.stringify(checkoutBody),
      })

      let changePasswordResult: ChangePasswordResult = res.ok ? { Kind: "Success" } : { Kind: "Error" }
      let result: HttpResult<ChangePasswordResult> = { kind: "result", value: changePasswordResult, status: 200 }
      return result
    })

export const changePersonalInfo = (personalInfoState: PersonalInfoState, invoiceToCompany: boolean, companyState: CompanyState): AsyncState<Unit> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let checkoutBody =
      {
        name: personalInfoState.input.name,
        surname: personalInfoState.input.surname,
        phoneNumber: personalInfoState.input.phoneNumber,
        gender: personalInfoState.input.gender,
        dateOfBirth: personalInfoState.input.dateOfBirth,
        invoiceAddress: {
          ...companyState.input,
          countryId: companyState.country.input.Id,
          type: companyState.companyType.input.Title
        },
        invoiceToCompany: invoiceToCompany,
        countryId: personalInfoState.countryState.input.Id,
        languageId: personalInfoState.languageState.input.Id,
        jobId: personalInfoState.jobState.input.Id,
        graduationYear: personalInfoState.input.graduationYear
      }
      let res = await fetch(`/api/v1/Checkout/ChangePersonalInfo`, {
        method: 'post', headers: headers,
        body: JSON.stringify(checkoutBody),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<Unit> = { kind: "result", value: json as Unit, status: 200 }
      return result
    })

export const createPendingShoppingCart = (): AsyncState<Unit> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'text/plain')
      // headers.append('content-type', 'application/json')
      // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/v1/Checkout/CreatePendingShoppingCart`, {
        method: 'post', credentials: 'include', headers: headers,
        redirect: 'follow', mode: 'no-cors',
        body: JSON.stringify({}),
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let result: HttpResult<Unit> = { kind: "result", value: json as Unit, status: 200 }
      return result
    })

const startSubscriptionStripeSession = (url: "portal" | "update-payment-method") => loadingAsyncState(
  async () => {
    let headers = new Headers()
    headers.append('content-type', 'application/json')

    let body = {
      Language: i18next.language
    }

    let res = await fetch(`/api/v1/checkout/${url}`, {
      method: 'post',
      headers: headers,
      body: JSON.stringify(body),
    })
    if (!res.ok) throw Error(res.statusText)
    let json = await res.json()

    let result: HttpResult<SubscriptionResult> = { kind: "result", value: {Kind: "Redirect", RedirectUrl: json.SessionUrl	}, status: 200 }
    return result
  })

export const startSubscriptionPortalSession = (): AsyncState<SubscriptionResult> => startSubscriptionStripeSession('portal');

export const startSubscriptionUpdatePaymentMethod = (): AsyncState<SubscriptionResult> => startSubscriptionStripeSession('update-payment-method');

export const getLookupData = (): AsyncState<LookupData> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')

      let res = await fetch(`/api/v1/Checkout/LookupData`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let received = json as LookupData
      let converted: LookupData = {
        Jobs: received.Jobs,
        Countries: received.Countries,
        Languages: received.Languages,
        IDealIssuers: received.IDealIssuers,
        Subscriptions: received.Subscriptions,
        Schools: received.Schools,
        CompanyTypes: received.CompanyTypes
      }

      let result: HttpResult<LookupData> = { kind: "result", value: converted, status: 200 }
      return result
    }
  )

export const getInvoices = (year: number): AsyncState<Array<Invoice>> =>
  loadingAsyncState(
    async () => {
      let headers = new Headers()
      headers.append('content-type', 'application/json')

      let res = await fetch(`/api/v1/Checkout/InvoicesForYear?year=${year}`, {
        method: 'get', credentials: 'include', headers: headers,
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()
      let received = json

      let result: HttpResult<Array<Invoice>> = { kind: "result", value: received.map((i: any) => ({ ...i, JsonBody: JSON.parse(i.JsonBody as any as string) })) as Array<Invoice>, status: 200 }
      return result
    }
  )